import { ReactElement, useState } from "react";
import {
  fetchUserPreferencesAtom,
  isConfigDialogOpenAtom,
  updateUserPreferencesAtom,
  userPreferencesAtom,
} from "atoms";
import { useAtomValue, useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";
import { ProfileSettings } from "@web-applications/allinga-web-components";

function ProfileSettingsWrapper(props: {
  handleCloseDialog: () => void;
}): ReactElement {
  const userPreferences = useAtomValue(userPreferencesAtom);
  const updateUserPreferences = useSetAtom(updateUserPreferencesAtom);
  const fetchUserPreferences = useSetAtom(fetchUserPreferencesAtom);
  const setConfigDialogOpen = useSetAtom(isConfigDialogOpenAtom);
  const { handleCloseDialog } = props;

  const [selectedLanguage, setSelectedLanguage] = useState(
    userPreferences.language || "en"
  );

  const [selectedAvatar, setSelectedAvatar] = useState(
    userPreferences.avatar ? userPreferences.avatar : ""
  );
  const { i18n } = useTranslation();

  const handleClose = () => {
    setConfigDialogOpen(false);
    handleCloseDialog();
  };

  const handleSaveClick = () => {
    handleClose();
    sessionStorage.setItem("language", selectedLanguage);
    updateUserPreferences({
      userAvatar: selectedAvatar,
      userLanguage: selectedLanguage,
    }).then();
    fetchUserPreferences().then();
    setTimeout(() => {
      i18n.changeLanguage(selectedLanguage).then();
    }, 1);
  };

  return (
    <ProfileSettings
      handleCloseClick={handleClose}
      handleSaveClick={handleSaveClick}
      selectedLanguage={selectedLanguage}
      selectedAvatar={selectedAvatar}
      setSelectedLanguage={setSelectedLanguage}
      setSelectedAvatar={setSelectedAvatar}
    />
  );
}

export default ProfileSettingsWrapper;
